import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
};

export type AbstractCuratedList = {
  __typename?: 'AbstractCuratedList';
  code?: Maybe<Scalars['String']>;
  guid: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  type: CuratedListType;
};

export type AbstractCuratedListPage = {
  __typename?: 'AbstractCuratedListPage';
  data?: Maybe<Array<Maybe<AbstractCuratedList>>>;
  meta?: Maybe<MetaPage>;
  next?: Maybe<NextPage>;
};

export type AcceptUserAgreementsInput = {
  kinds: Array<InputMaybe<LegalAgreementKindEnum>>;
};

export type AccountBalanceSummary = {
  __typename?: 'AccountBalanceSummary';
  accountingStatus: AccountStatusEnum;
  balance?: Maybe<Scalars['Float']>;
  currencyCode?: Maybe<Scalars['String']>;
  currencySymbol?: Maybe<Scalars['String']>;
  overduePayments: Array<OverduePayment>;
};

export enum AccountStatusEnum {
  Collection = 'Collection',
  Good = 'Good',
  PoorStanding = 'PoorStanding'
}

export type Agreement = {
  __typename?: 'Agreement';
  kind: LegalAgreementKindEnum;
  requireUpdate?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};

export type Agreements = {
  __typename?: 'Agreements';
  agreements?: Maybe<Array<Maybe<Agreement>>>;
};

export type AllSubscriptions = {
  __typename?: 'AllSubscriptions';
  subscriptions?: Maybe<Array<Maybe<CurrentSubscription>>>;
};

export type AlternateLanguage = {
  __typename?: 'AlternateLanguage';
  id: Scalars['ID'];
  lang: Scalars['String'];
  type: Scalars['String'];
  uid?: Maybe<Scalars['String']>;
};

export type Artist = {
  __typename?: 'Artist';
  artworkUrl?: Maybe<Scalars['String']>;
  coverUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  guid: Scalars['ID'];
  isExclusive: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  packCount?: Maybe<Scalars['Int']>;
  portraitUrl?: Maybe<Scalars['String']>;
  sampleCount?: Maybe<Scalars['Int']>;
  seoMetadata?: Maybe<SeoMetadata>;
  slug?: Maybe<Scalars['String']>;
};

export type Balance = {
  __typename?: 'Balance';
  balance?: Maybe<Scalars['Int']>;
};

export enum BpmMultiplier {
  Double = 'Double',
  Half = 'Half',
  None = 'None'
}

export type Collection = {
  __typename?: 'Collection';
  artworkUrl?: Maybe<Scalars['String']>;
  guid: Scalars['ID'];
  isDownloaded: Scalars['Boolean'];
  isExclusive: Scalars['Boolean'];
  isFavorited: Scalars['Boolean'];
  isFree: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  subType: RepackSubType;
  type: PackType;
};

export type ContentGroup = {
  __typename?: 'ContentGroup';
  byline: Scalars['String'];
  contentLists: Array<Maybe<ContentList>>;
  guid: Scalars['ID'];
  target: ContentTarget;
  title: Scalars['String'];
};

export type ContentList = {
  __typename?: 'ContentList';
  items: Array<Maybe<ContentListItem>>;
  tabName: Scalars['String'];
};

export type ContentListItem = Pack | Repack;

export enum ContentTarget {
  AuthenticatedOnly = 'AuthenticatedOnly',
  GuestAndAuthenticated = 'GuestAndAuthenticated',
  GuestOnly = 'GuestOnly'
}

export type CostPreviewResponse = {
  __typename?: 'CostPreviewResponse';
  credits?: Maybe<Scalars['Int']>;
  remainingCredits?: Maybe<Scalars['Int']>;
};

export type CreatorSession = {
  __typename?: 'CreatorSession';
  bpm?: Maybe<Scalars['Int']>;
  guid: Scalars['ID'];
  isPublic?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Key>;
  name?: Maybe<Scalars['String']>;
  samples?: Maybe<Array<Maybe<Track>>>;
  userId?: Maybe<Scalars['ID']>;
  version?: Maybe<Scalars['Int']>;
};

export type CreatorSessionInput = {
  bpm: Scalars['Int'];
  guid?: InputMaybe<Scalars['ID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<KeyInput>;
  name?: InputMaybe<Scalars['String']>;
  samples?: InputMaybe<Array<InputMaybe<TrackInput>>>;
  version: Scalars['Int'];
};

export type CreditBalancePayloadType = {
  __typename?: 'CreditBalancePayloadType';
  hdwav?: Maybe<Balance>;
  mp3?: Maybe<Balance>;
  sample?: Maybe<Balance>;
  wav?: Maybe<Balance>;
};

export type CuratedList = {
  __typename?: 'CuratedList';
  browseUrl?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  data: Array<CuratedListDataType>;
  description?: Maybe<Scalars['String']>;
  guid: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  type: CuratedListType;
};

export type CuratedListDataType = Artist | Genre | Instrument | Label | Pack | Repack | Sample;

export type CuratedListFeed = {
  __typename?: 'CuratedListFeed';
  feed?: Maybe<Array<Maybe<CuratedListDataType>>>;
  meta?: Maybe<CuratedListMeta>;
};


export type CuratedListFeedFeedArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
  take?: InputMaybe<Scalars['Int']>;
  type: CuratedListType;
};

export type CuratedListGroup = {
  __typename?: 'CuratedListGroup';
  code: Scalars['ID'];
  curatedLists?: Maybe<AbstractCuratedListPage>;
  description?: Maybe<Scalars['String']>;
};

export type CuratedListMeta = {
  __typename?: 'CuratedListMeta';
  browseUrl?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  guid: Scalars['ID'];
  meta?: Maybe<MetaPage>;
  name?: Maybe<Scalars['String']>;
  type: CuratedListType;
};

export type CuratedListPage = {
  __typename?: 'CuratedListPage';
  data?: Maybe<Array<Maybe<CuratedList>>>;
  meta?: Maybe<MetaPage>;
  next?: Maybe<NextPage>;
};

export enum CuratedListType {
  Artists = 'artists',
  Genres = 'genres',
  Groups = 'groups',
  Instruments = 'instruments',
  Labels = 'labels',
  Packs = 'packs',
  Repacks = 'repacks',
  Samples = 'samples'
}

export type CurrentSubscription = {
  __typename?: 'CurrentSubscription';
  activationDate?: Maybe<Scalars['String']>;
  creationDate: Scalars['String'];
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  nextPeriodStartDate?: Maybe<Scalars['String']>;
  plan: PlanFrequencyIdentifier;
  segment?: Maybe<Scalars['String']>;
  serviceOffer: ServiceOfferKind;
  status: SubscriptionStatusEnum;
};

export type Descriptor = {
  __typename?: 'Descriptor';
  code?: Maybe<Scalars['String']>;
};

export type FilterMeta = {
  __typename?: 'FilterMeta';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type Filters = {
  __typename?: 'Filters';
  descriptorFilters?: Maybe<Array<Maybe<FilterMeta>>>;
  genreFilters?: Maybe<Array<Maybe<FilterMeta>>>;
  instrumentFilters?: Maybe<Array<Maybe<FilterMeta>>>;
  sampleTypeFilters?: Maybe<Array<Maybe<FilterMeta>>>;
  sfxFilters?: Maybe<Array<Maybe<FilterMeta>>>;
  tagFilters?: Maybe<Array<Maybe<FilterMeta>>>;
};

export type Genre = {
  __typename?: 'Genre';
  code?: Maybe<Scalars['String']>;
  subGenres?: Maybe<Array<Maybe<Genre>>>;
};

export type GenreInput = {
  code?: InputMaybe<Scalars['String']>;
  subGenres?: InputMaybe<Array<InputMaybe<GenreInput>>>;
};

export type HeroBanner = {
  __typename?: 'HeroBanner';
  byline?: Maybe<Scalars['String']>;
  contentType: HeroBannerContentType;
  description?: Maybe<Scalars['String']>;
  entity: HeroBannerEntityType;
  genres?: Maybe<Array<Maybe<Genre>>>;
  guid: Scalars['String'];
  instruments?: Maybe<Array<Maybe<Instrument>>>;
  labelPacks?: Maybe<Array<Maybe<Pack>>>;
  title?: Maybe<Scalars['String']>;
};

export enum HeroBannerContentType {
  Collection = 'Collection',
  Label = 'Label',
  Pack = 'Pack'
}

export type HeroBannerEntityType = Label | Pack | Repack;

export enum HomePageEnum {
  Chromatic = 'Chromatic',
  Dashboard = 'Dashboard',
  Distribution = 'Distribution',
  Mastering = 'Mastering',
  Network = 'Network',
  Plugins = 'Plugins',
  Projects = 'Projects',
  Samples = 'Samples',
  Sessions = 'Sessions'
}

export type Instrument = {
  __typename?: 'Instrument';
  code?: Maybe<Scalars['String']>;
  isFamily?: Maybe<Scalars['Boolean']>;
  subInstruments?: Maybe<Array<Maybe<Instrument>>>;
};

export type InstrumentInput = {
  code?: InputMaybe<Scalars['String']>;
  isFamily?: InputMaybe<Scalars['Boolean']>;
  subInstruments?: InputMaybe<Array<InputMaybe<InstrumentInput>>>;
};

export enum Interval {
  Monthly = 'Monthly',
  Yearly = 'Yearly'
}

export type Key = {
  __typename?: 'Key';
  quality?: Maybe<KeyQuality>;
  root?: Maybe<KeyRootApi>;
  sign?: Maybe<KeySign>;
};

export type KeyInput = {
  quality?: InputMaybe<KeyQuality>;
  root?: InputMaybe<KeyRootApi>;
  sign?: InputMaybe<KeySign>;
};

export enum KeyQuality {
  Major = 'major',
  Minor = 'minor'
}

export enum KeyRootApi {
  A = 'A',
  ASharpBFlat = 'ASharpBFlat',
  B = 'B',
  C = 'C',
  CSharpDFlat = 'CSharpDFlat',
  D = 'D',
  DSharpEFlat = 'DSharpEFlat',
  E = 'E',
  F = 'F',
  FSharpGFlat = 'FSharpGFlat',
  G = 'G',
  GSharpAFlat = 'GSharpAFlat'
}

export enum KeySign {
  Flat = 'Flat',
  Sharp = 'Sharp'
}

export type Label = {
  __typename?: 'Label';
  artworkUrl?: Maybe<Scalars['String']>;
  coverUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  guid: Scalars['ID'];
  isExclusive: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  packCount?: Maybe<Scalars['Int']>;
  sampleCount?: Maybe<Scalars['Int']>;
  seoMetadata?: Maybe<SeoMetadata>;
  slug?: Maybe<Scalars['String']>;
};

export type LabelsChart = {
  __typename?: 'LabelsChart';
  items: Array<Maybe<LabelsChartItem>>;
};

export type LabelsChartItem = {
  __typename?: 'LabelsChartItem';
  artistName?: Maybe<Scalars['String']>;
  artworkUrl: Scalars['String'];
  currentRank: Scalars['Int'];
  guid: Scalars['ID'];
  isNew: Scalars['Boolean'];
  lastRank?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  subItemsCount?: Maybe<Scalars['Int']>;
};

export enum LegalAgreementKindEnum {
  PrivacyPolicy = 'PrivacyPolicy',
  TermsOfService = 'TermsOfService'
}

export enum Locale {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it',
  Ja = 'ja',
  Pt = 'pt'
}

export type MerchZone = {
  __typename?: 'MerchZone';
  contentGroups: Array<ContentGroup>;
};

export type MetaPage = {
  __typename?: 'MetaPage';
  filters?: Maybe<Filters>;
  totalPackRecords?: Maybe<Scalars['Int']>;
  totalRecords?: Maybe<Scalars['Int']>;
  totalRepackRecords?: Maybe<Scalars['Int']>;
  totalSampleRecords?: Maybe<Scalars['Int']>;
};

export enum MusicGenre {
  Acoustic = 'Acoustic',
  Afrobeat = 'Afrobeat',
  Americana = 'Americana',
  Blues = 'Blues',
  Chill = 'Chill',
  Choral = 'Choral',
  Classical = 'Classical',
  Country = 'Country',
  Dubstep = 'Dubstep',
  Edm = 'Edm',
  ElectricPop = 'Electric_pop',
  Electronic = 'Electronic',
  Folk = 'Folk',
  Funk = 'Funk',
  Gospel = 'Gospel',
  HeavyMetal = 'Heavy_metal',
  HeavyRock = 'Heavy_rock',
  HipHop = 'Hip_hop',
  House = 'House',
  IndiePop = 'Indie_pop',
  Jazz = 'Jazz',
  Latin = 'Latin',
  Pop = 'Pop',
  PopRock = 'Pop_rock',
  Reggae = 'Reggae',
  Reggaeton = 'Reggaeton',
  Rnb = 'Rnb',
  Rock = 'Rock',
  SingerSongwriter = 'Singer_songwriter',
  SoftPop = 'Soft_pop',
  Soul = 'Soul',
  Soundtrack = 'Soundtrack',
  Techno = 'Techno',
  Trance = 'Trance',
  Trap = 'Trap',
  Tropical = 'Tropical',
  World = 'World'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptUserAgreements?: Maybe<Scalars['Boolean']>;
  addSamplesToUserCollection?: Maybe<UserCollection>;
  createUserCollection?: Maybe<UserCollection>;
  createUserRecentSearch?: Maybe<Scalars['String']>;
  deleteUserCollection?: Maybe<Scalars['String']>;
  deleteUserRecentSearch?: Maybe<Scalars['String']>;
  editUserCollection?: Maybe<Scalars['String']>;
  putMilestones: Array<Scalars['String']>;
  removeSamplesFromUserCollection?: Maybe<UserCollection>;
  storeCreatorSession?: Maybe<CreatorSession>;
  updatePackFavoritedState?: Maybe<Pack>;
  updateRepackFavoritedState?: Maybe<Repack>;
  updateSampleFavoritedState?: Maybe<Sample>;
};


export type MutationAcceptUserAgreementsArgs = {
  agreements: AcceptUserAgreementsInput;
};


export type MutationAddSamplesToUserCollectionArgs = {
  collectionGuid?: InputMaybe<Scalars['ID']>;
  sampleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationCreateUserCollectionArgs = {
  name?: InputMaybe<Scalars['String']>;
  sampleCount?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateUserRecentSearchArgs = {
  filterSlug: Scalars['String'];
  filterType: UserSearchFilter;
};


export type MutationDeleteUserCollectionArgs = {
  collectionGuid?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteUserRecentSearchArgs = {
  filterSlug: Scalars['String'];
  filterType: UserSearchFilter;
};


export type MutationEditUserCollectionArgs = {
  collectionGuid?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationPutMilestonesArgs = {
  milestones: Array<Scalars['String']>;
};


export type MutationRemoveSamplesFromUserCollectionArgs = {
  collectionGuid?: InputMaybe<Scalars['ID']>;
  sampleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationStoreCreatorSessionArgs = {
  session?: InputMaybe<CreatorSessionInput>;
};


export type MutationUpdatePackFavoritedStateArgs = {
  pack: PackFavoritedInput;
};


export type MutationUpdateRepackFavoritedStateArgs = {
  repack: RepackFavoritedInput;
};


export type MutationUpdateSampleFavoritedStateArgs = {
  sample: SampleFavoritedInput;
};

export type NextPage = {
  __typename?: 'NextPage';
  skip?: Maybe<Scalars['Int']>;
};

export enum OccupationEnum {
  AR = 'A_R',
  Agent = 'Agent',
  Artist = 'Artist',
  ArtistManager = 'Artist_manager',
  Bassist = 'Bassist',
  Beatmaker = 'Beatmaker',
  Blogger = 'Blogger',
  Composer = 'Composer',
  Copywriter = 'Copywriter',
  Dj = 'DJ',
  Designer = 'Designer',
  Drummer = 'Drummer',
  Educator = 'Educator',
  Engineer = 'Engineer',
  EventProgrammer = 'Event_programmer',
  GearManufacturer = 'Gear_manufacturer',
  GraphicDesigner = 'Graphic_designer',
  Guitarist = 'Guitarist',
  Influencer = 'Influencer',
  Instrumentalist = 'Instrumentalist',
  Journalist = 'Journalist',
  Keyboardist = 'Keyboardist',
  LabelOwner = 'Label_owner',
  Lyricist = 'Lyricist',
  MediaFigure = 'Media_figure',
  Moderator = 'Moderator',
  MultiInstrumentalist = 'Multi_instrumentalist',
  MusicDirector = 'Music_director',
  Musician = 'Musician',
  Photographer = 'Photographer',
  Pianist = 'Pianist',
  PodcastHost = 'Podcast_host',
  Producer = 'Producer',
  Promoter = 'Promoter',
  Publicist = 'Publicist',
  Publisher = 'Publisher',
  RadioHost = 'Radio_host',
  Singer = 'Singer',
  Songwriter = 'Songwriter',
  SoundDesign = 'Sound_design',
  StudioOwner = 'Studio_owner',
  Videographer = 'Videographer',
  Vlogger = 'Vlogger',
  WebDesigner = 'Web_designer',
  YouTuber = 'YouTuber'
}

export type OverduePayment = {
  __typename?: 'OverduePayment';
  serviceOffer: ServiceOfferKind;
};

export type Pack = {
  __typename?: 'Pack';
  artist?: Maybe<Artist>;
  artworkUrl?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  creatorSession?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  foregroundColor?: Maybe<Scalars['String']>;
  genres?: Maybe<Array<Maybe<Genre>>>;
  guid: Scalars['ID'];
  id: Scalars['Int'];
  isDownloaded: Scalars['Boolean'];
  isExclusive: Scalars['Boolean'];
  isFavorited: Scalars['Boolean'];
  isFree: Scalars['Boolean'];
  label?: Maybe<Label>;
  mainGenre?: Maybe<Genre>;
  name?: Maybe<Scalars['String']>;
  packState: PackState;
  premiumCodes?: Maybe<Array<Maybe<PremiumCodes>>>;
  sampleCount?: Maybe<Scalars['Int']>;
  seoMetadata?: Maybe<SeoMetadata>;
  sfxs?: Maybe<Array<Maybe<Sfx>>>;
  slug?: Maybe<Scalars['String']>;
  type: PackType;
};

export type PackFavoritedInput = {
  guid: Scalars['ID'];
  isFavorited?: InputMaybe<Scalars['Boolean']>;
};

export enum PackState {
  Draft = 'Draft',
  PublicationFailed = 'PublicationFailed',
  Published = 'Published',
  Publishing = 'Publishing',
  TakenDown = 'TakenDown'
}

export enum PackType {
  Pack = 'Pack',
  Repack = 'Repack'
}

export type PackagesMeta = {
  __typename?: 'PackagesMeta';
  url?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type PacksChart = {
  __typename?: 'PacksChart';
  items: Array<Maybe<PacksChartItem>>;
};

export type PacksChartItem = {
  __typename?: 'PacksChartItem';
  artistName?: Maybe<Scalars['String']>;
  artworkUrl: Scalars['String'];
  currentRank: Scalars['Int'];
  guid: Scalars['ID'];
  isNew: Scalars['Boolean'];
  lastRank?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  subItemsCount?: Maybe<Scalars['Int']>;
};

export type PacksOrRepacks = Pack | Repack;

export type PaginatedArtists = {
  __typename?: 'PaginatedArtists';
  data?: Maybe<Array<Maybe<Artist>>>;
  meta?: Maybe<MetaPage>;
  next?: Maybe<NextPage>;
};

export type PaginatedLabels = {
  __typename?: 'PaginatedLabels';
  data?: Maybe<Array<Maybe<Label>>>;
  meta?: Maybe<MetaPage>;
  next?: Maybe<NextPage>;
};

export type PaginatedPacks = {
  __typename?: 'PaginatedPacks';
  data?: Maybe<Array<Maybe<Pack>>>;
  meta?: Maybe<MetaPage>;
  next?: Maybe<NextPage>;
};

export type PaginatedPacksOrRepacks = {
  __typename?: 'PaginatedPacksOrRepacks';
  data?: Maybe<Array<Maybe<PacksOrRepacks>>>;
  meta?: Maybe<MetaPage>;
  next?: Maybe<NextPage>;
};

export type PaginatedRepacks = {
  __typename?: 'PaginatedRepacks';
  data?: Maybe<Array<Maybe<Repack>>>;
  meta?: Maybe<MetaPage>;
  next?: Maybe<NextPage>;
};

export type PaginatedSamples = {
  __typename?: 'PaginatedSamples';
  data?: Maybe<Array<Maybe<Sample>>>;
  meta?: Maybe<MetaPage>;
  next?: Maybe<NextPage>;
};

export type PaginatedUserCollections = {
  __typename?: 'PaginatedUserCollections';
  data?: Maybe<Array<Maybe<UserCollection>>>;
  meta?: Maybe<MetaPage>;
  next?: Maybe<NextPage>;
};

export type PlanFrequencyIdentifier = {
  __typename?: 'PlanFrequencyIdentifier';
  code: Scalars['String'];
  frequency?: Maybe<Interval>;
};

export type PluginPackages = {
  __typename?: 'PluginPackages';
  macOS?: Maybe<PackagesMeta>;
  windows?: Maybe<PackagesMeta>;
};

export enum PremiumCodes {
  LandrStudio = 'landr_studio',
  SamplesPro = 'samples_pro',
  SamplesTier1 = 'samples_tier1',
  SamplesTier2 = 'samples_tier2',
  SamplesTier3 = 'samples_tier3'
}

export type PrismicBackgroundImage = {
  __typename?: 'PrismicBackgroundImage';
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions: PrismicImageDimensions;
  regular: PrismicImage;
  url: Scalars['String'];
};

export type PrismicBanner = {
  __typename?: 'PrismicBanner';
  first_publication_date: Scalars['Date'];
  id: Scalars['ID'];
  isBroken?: Maybe<Scalars['Boolean']>;
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  link_type: Scalars['String'];
  slug: Scalars['String'];
  tags: Array<Maybe<Scalars['String']>>;
  type: Scalars['String'];
};

export type PrismicBannerData = PrismicSampleAuthBannerData | PrismicSampleBannerData | PrismicSampleBannerGroupData;

export type PrismicDocument = {
  __typename?: 'PrismicDocument';
  alternate_languages: Array<Maybe<AlternateLanguage>>;
  data: PrismicBannerData;
  first_publication_date: Scalars['String'];
  href: Scalars['String'];
  id: Scalars['ID'];
  lang: Scalars['String'];
  last_publication_date: Scalars['String'];
  slugs: Array<Maybe<Scalars['String']>>;
  tags: Array<Maybe<Scalars['String']>>;
  type: Scalars['String'];
  uid?: Maybe<Scalars['String']>;
};

export type PrismicImage = {
  __typename?: 'PrismicImage';
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions: PrismicImageDimensions;
  url: Scalars['String'];
};

export type PrismicImageDimensions = {
  __typename?: 'PrismicImageDimensions';
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type PrismicSampleAuthBannerCtaLink = {
  __typename?: 'PrismicSampleAuthBannerCtaLink';
  authenticated_cta_link: Array<PrismicTextField>;
  guest_cta_link: Array<PrismicTextField>;
};

export type PrismicSampleAuthBannerCtaText = {
  __typename?: 'PrismicSampleAuthBannerCtaText';
  authenticated_cta_text: Array<PrismicTextField>;
  guest_cta_text: Array<PrismicTextField>;
};

export type PrismicSampleAuthBannerData = {
  __typename?: 'PrismicSampleAuthBannerData';
  background_image: PrismicBackgroundImage;
  banner_title: Array<PrismicTextField>;
  cta_link: Array<PrismicSampleAuthBannerCtaLink>;
  cta_text: Array<PrismicSampleAuthBannerCtaText>;
  description: Array<PrismicSampleAuthBannerDescription>;
  title: Array<PrismicSampleAuthBannerTitle>;
};

export type PrismicSampleAuthBannerDescription = {
  __typename?: 'PrismicSampleAuthBannerDescription';
  authenticated_description: Array<PrismicTextField>;
  guest_description: Array<PrismicTextField>;
};

export type PrismicSampleAuthBannerTitle = {
  __typename?: 'PrismicSampleAuthBannerTitle';
  authenticated_title: Array<PrismicTextField>;
  guest_title: Array<PrismicTextField>;
};

export type PrismicSampleBannerData = {
  __typename?: 'PrismicSampleBannerData';
  background_color?: Maybe<Scalars['String']>;
  background_image: PrismicBackgroundImage;
  banner_title: Array<PrismicTextField>;
  cta_path: Array<PrismicTextField>;
  cta_text: Array<PrismicTextField>;
  description: Array<PrismicTextField>;
  title: Array<PrismicTextField>;
};

export type PrismicSampleBannerGroupData = {
  __typename?: 'PrismicSampleBannerGroupData';
  banner_a: PrismicBanner;
  banner_b: PrismicBanner;
  banner_c: PrismicBanner;
  banner_d: PrismicBanner;
  banner_e: PrismicBanner;
  title: Array<PrismicTextField>;
};

export type PrismicTextField = {
  __typename?: 'PrismicTextField';
  spans: Array<Maybe<Scalars['String']>>;
  text: Scalars['String'];
  type: Scalars['String'];
};

export type PromotionalCard = {
  __typename?: 'PromotionalCard';
  backgroundColor: Scalars['String'];
  ctaText: Scalars['String'];
  ctaUrl: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  imageHoverUrl?: Maybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  isPrioritized: Scalars['Boolean'];
  title: Scalars['String'];
  type: PromotionalCardType;
};

export enum PromotionalCardType {
  Creator = 'creator',
  None = 'none',
  Plugin = 'plugin',
  QuickPicks = 'quick_picks'
}

export enum ProviderType {
  Aggregator = 'AGGREGATOR',
  Artist = 'ARTIST',
  Label = 'LABEL'
}

export type PurchasableCreatorSample = {
  gainDb?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  semitoneShift?: InputMaybe<Scalars['Float']>;
  timeFactor?: InputMaybe<Scalars['Float']>;
};

export type PurchasableCreatorSession = {
  async?: InputMaybe<Scalars['Boolean']>;
  samples?: InputMaybe<Array<InputMaybe<PurchasableCreatorSample>>>;
  targetBpm?: InputMaybe<Scalars['Int']>;
  targetKey?: InputMaybe<Scalars['String']>;
  targetKeyQuality?: InputMaybe<Scalars['String']>;
  targetKeyRoot?: InputMaybe<Scalars['String']>;
};

export type PurchaseResponse = {
  __typename?: 'PurchaseResponse';
  url?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  accountBalanceSummary?: Maybe<AccountBalanceSummary>;
  artistBySlug?: Maybe<Artist>;
  bannerGroup: Array<PrismicDocument>;
  chartsTopLabels?: Maybe<LabelsChart>;
  chartsTopLandrPacks?: Maybe<RepacksChart>;
  chartsTopPacks?: Maybe<PacksChart>;
  collectionCostPreview?: Maybe<CostPreviewResponse>;
  collectionPurchase?: Maybe<PurchaseResponse>;
  contentGroup?: Maybe<ContentGroup>;
  creatorMixdownPurchase?: Maybe<PurchaseResponse>;
  creatorSamplesCostPreview?: Maybe<CostPreviewResponse>;
  creatorSamplesPurchase?: Maybe<PurchaseResponse>;
  creatorSessionById?: Maybe<CreatorSession>;
  curatedList?: Maybe<CuratedList>;
  curatedListFeed?: Maybe<CuratedListFeed>;
  curatedListGroup?: Maybe<CuratedListGroup>;
  genres?: Maybe<Array<Maybe<Genre>>>;
  getUserRecentSearch: UserRecentSearches;
  heroBanners?: Maybe<Array<Maybe<HeroBanner>>>;
  instruments?: Maybe<Array<Maybe<Instrument>>>;
  labelBySlug?: Maybe<Label>;
  lastCreatorSession?: Maybe<CreatorSession>;
  merchZone?: Maybe<MerchZone>;
  milestones: Array<Scalars['String']>;
  pack?: Maybe<Pack>;
  packCostPreview?: Maybe<CostPreviewResponse>;
  packPurchase?: Maybe<PurchaseResponse>;
  packStream?: Maybe<StreamUrl>;
  paginatedArtistPacks?: Maybe<PaginatedPacks>;
  paginatedArtistSamples?: Maybe<PaginatedSamples>;
  paginatedArtists?: Maybe<PaginatedArtists>;
  paginatedDownloadedPacksAndRepacksV2?: Maybe<PaginatedPacksOrRepacks>;
  paginatedDownloadedSamples?: Maybe<PaginatedSamples>;
  paginatedFavoritedPacksAndRepacksV2?: Maybe<PaginatedPacksOrRepacks>;
  paginatedFavoritedSamples?: Maybe<PaginatedSamples>;
  paginatedLabelPacks?: Maybe<PaginatedPacks>;
  paginatedLabelSamples?: Maybe<PaginatedSamples>;
  paginatedLabels?: Maybe<PaginatedLabels>;
  paginatedPackSamples?: Maybe<PaginatedSamples>;
  paginatedPacks?: Maybe<PaginatedPacks>;
  paginatedPacksAndRepacks?: Maybe<PaginatedPacksOrRepacks>;
  paginatedRecommendedSamples?: Maybe<PaginatedSamples>;
  paginatedRepackSamples?: Maybe<PaginatedSamples>;
  paginatedRepacks?: Maybe<PaginatedRepacks>;
  paginatedSamples?: Maybe<PaginatedSamples>;
  paginatedUserCollectionSamples?: Maybe<PaginatedSamples>;
  paginatedUserCollections?: Maybe<PaginatedUserCollections>;
  pluginPackages?: Maybe<PluginPackages>;
  promotionalCardsRepeater: Array<PromotionalCard>;
  repack?: Maybe<Repack>;
  repackCostPreview?: Maybe<CostPreviewResponse>;
  repackPurchase?: Maybe<PurchaseResponse>;
  repackStream?: Maybe<StreamUrl>;
  sample?: Maybe<Sample>;
  sampleStream?: Maybe<StreamUrl>;
  sampleWaveform?: Maybe<Waveform>;
  samplesCostPreview?: Maybe<CostPreviewResponse>;
  samplesPurchase?: Maybe<PurchaseResponse>;
  seoByUrl?: Maybe<Seo>;
  sfxs?: Maybe<Array<Maybe<Sfx>>>;
  similarPacks?: Maybe<PaginatedPacks>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  userAgreements?: Maybe<Agreements>;
  userAllAccess: Scalars['Boolean'];
  userAllSubscriptions?: Maybe<AllSubscriptions>;
  userCollection?: Maybe<UserCollection>;
  userCollections?: Maybe<Array<Maybe<UserCollection>>>;
  userCollectionsFeed?: Maybe<UserCollectionsFeed>;
  userCredits?: Maybe<UserCredits>;
  userHasSubscription: Scalars['Boolean'];
  userProfile?: Maybe<User>;
  userSamplesSubscription?: Maybe<CurrentSubscription>;
};


export type QueryArtistBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryBannerGroupArgs = {
  locale?: InputMaybe<Locale>;
};


export type QueryCollectionCostPreviewArgs = {
  guid?: InputMaybe<Scalars['String']>;
};


export type QueryCollectionPurchaseArgs = {
  guid?: InputMaybe<Scalars['String']>;
};


export type QueryContentGroupArgs = {
  guid: Scalars['ID'];
};


export type QueryCreatorMixdownPurchaseArgs = {
  purchasableItem: PurchasableCreatorSession;
};


export type QueryCreatorSamplesCostPreviewArgs = {
  guid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCreatorSamplesPurchaseArgs = {
  purchasableItem: PurchasableCreatorSession;
};


export type QueryCreatorSessionByIdArgs = {
  sessionId?: InputMaybe<Scalars['ID']>;
};


export type QueryCuratedListArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
  take?: InputMaybe<Scalars['Int']>;
  type: CuratedListType;
};


export type QueryCuratedListFeedArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
  take?: InputMaybe<Scalars['Int']>;
  type: CuratedListType;
};


export type QueryCuratedListGroupArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryLabelBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryMerchZoneArgs = {
  slug: Scalars['ID'];
};


export type QueryPackArgs = {
  packSlugOrGuid: Scalars['ID'];
};


export type QueryPackCostPreviewArgs = {
  guid?: InputMaybe<Scalars['String']>;
};


export type QueryPackPurchaseArgs = {
  guid?: InputMaybe<Scalars['String']>;
};


export type QueryPackStreamArgs = {
  packGuid: Scalars['ID'];
};


export type QueryPaginatedArtistPacksArgs = {
  artistGuid?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedArtistSamplesArgs = {
  artistGuid?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedArtistsArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedDownloadedPacksAndRepacksV2Args = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedDownloadedSamplesArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedFavoritedPacksAndRepacksV2Args = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedFavoritedSamplesArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedLabelPacksArgs = {
  labelGuid?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedLabelSamplesArgs = {
  labelGuid?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedLabelsArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedPackSamplesArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  packGuid?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedPacksArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedPacksAndRepacksArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedRecommendedSamplesArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sampleGuid: Scalars['ID'];
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedRepackSamplesArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  repackGuid?: InputMaybe<Scalars['ID']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedRepacksArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  subType?: InputMaybe<RepackSubType>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedSamplesArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedUserCollectionSamplesArgs = {
  collectionGuid?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPaginatedUserCollectionsArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPromotionalCardsRepeaterArgs = {
  locale?: InputMaybe<Locale>;
};


export type QueryRepackArgs = {
  repackSlugOrGuid: Scalars['ID'];
};


export type QueryRepackCostPreviewArgs = {
  guid?: InputMaybe<Scalars['String']>;
};


export type QueryRepackPurchaseArgs = {
  guid?: InputMaybe<Scalars['String']>;
};


export type QueryRepackStreamArgs = {
  repackGuid: Scalars['ID'];
};


export type QuerySampleArgs = {
  sampleGuid: Scalars['ID'];
};


export type QuerySampleStreamArgs = {
  sampleGuid: Scalars['ID'];
};


export type QuerySampleWaveformArgs = {
  sampleGuid: Scalars['ID'];
  waveformUrl: Scalars['String'];
};


export type QuerySamplesCostPreviewArgs = {
  guid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySamplesPurchaseArgs = {
  guid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySeoByUrlArgs = {
  url?: InputMaybe<Scalars['ID']>;
};


export type QuerySimilarPacksArgs = {
  packSlugOrGuid: Scalars['ID'];
};


export type QueryUserCollectionArgs = {
  collectionGuid?: InputMaybe<Scalars['ID']>;
};


export type QueryUserCollectionsArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUserCollectionsFeedArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type Repack = {
  __typename?: 'Repack';
  artist?: Maybe<Artist>;
  artworkUrl?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  creatorSession?: Maybe<Scalars['ID']>;
  dateCreated: Scalars['String'];
  datePublished?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  foregroundColor?: Maybe<Scalars['String']>;
  genres?: Maybe<Array<Maybe<Genre>>>;
  guid: Scalars['ID'];
  id: Scalars['Int'];
  instrument?: Maybe<Instrument>;
  isDownloaded: Scalars['Boolean'];
  isExclusive: Scalars['Boolean'];
  isFavorited: Scalars['Boolean'];
  isFree: Scalars['Boolean'];
  label?: Maybe<Label>;
  mainGenre?: Maybe<Genre>;
  name?: Maybe<Scalars['String']>;
  packState: PackState;
  premiumCodes?: Maybe<Array<Maybe<PremiumCodes>>>;
  sampleCount?: Maybe<Scalars['Int']>;
  seoMetadata?: Maybe<SeoMetadata>;
  sfxs?: Maybe<Array<Maybe<Sfx>>>;
  slug?: Maybe<Scalars['String']>;
  subType?: Maybe<RepackSubType>;
  type: PackType;
};

export type RepackFavoritedInput = {
  guid: Scalars['ID'];
  isFavorited: Scalars['Boolean'];
};

export enum RepackSubType {
  Chart = 'Chart',
  Collection = 'Collection',
  Creator = 'Creator'
}

export type RepacksChart = {
  __typename?: 'RepacksChart';
  items: Array<Maybe<PacksChartItem>>;
};

export type RepacksChartItem = {
  __typename?: 'RepacksChartItem';
  artistName?: Maybe<Scalars['String']>;
  artworkUrl: Scalars['String'];
  currentRank: Scalars['Int'];
  guid: Scalars['ID'];
  isNew: Scalars['Boolean'];
  lastRank?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  subItemsCount: Scalars['Int'];
};

export type Sample = {
  __typename?: 'Sample';
  bpm?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
  /** @deprecated Use tags */
  descriptors?: Maybe<Array<Maybe<Descriptor>>>;
  duration?: Maybe<Scalars['Float']>;
  guid: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  instruments?: Maybe<Array<Maybe<Instrument>>>;
  isDownloaded: Scalars['Boolean'];
  isFavorited: Scalars['Boolean'];
  isRecommendationFiller?: Maybe<Scalars['Boolean']>;
  key?: Maybe<SampleKey>;
  name?: Maybe<Scalars['String']>;
  pack?: Maybe<Pack>;
  sampleState: SampleState;
  sampleType?: Maybe<SampleType>;
  sfxs?: Maybe<Array<Maybe<Sfx>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  waveformUrl?: Maybe<Scalars['String']>;
};

export type SampleFavoritedInput = {
  guid: Scalars['ID'];
  isFavorited?: InputMaybe<Scalars['Boolean']>;
};

export type SampleKey = {
  __typename?: 'SampleKey';
  code?: Maybe<Scalars['String']>;
  quality?: Maybe<KeyQuality>;
  root?: Maybe<KeyRootApi>;
  sanitizedCode?: Maybe<Scalars['String']>;
};

export type SampleKeyInput = {
  code?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<KeyQuality>;
  root?: InputMaybe<KeyRootApi>;
  sanitizedCode?: InputMaybe<Scalars['String']>;
};

export enum SampleState {
  Available = 'Available',
  TakenDown = 'TakenDown'
}

export enum SampleType {
  Loop = 'loop',
  OneShot = 'one_shot'
}

export type Seo = {
  __typename?: 'Seo';
  byline?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SeoItem = {
  __typename?: 'SeoItem';
  seoMetadata?: Maybe<SeoMetadata>;
  slug?: Maybe<Scalars['String']>;
};

export type SeoMetadata = {
  __typename?: 'SeoMetadata';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type SeoMetadataInput = {
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum ServiceOfferKind {
  Bundles = 'Bundles',
  Chromatic = 'Chromatic',
  Distribution = 'Distribution',
  Mastering = 'Mastering',
  MasteringAndDistribution = 'MasteringAndDistribution',
  Samples = 'Samples',
  Sessions = 'Sessions',
  Video = 'Video'
}

export enum ServiceStatusEnum {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Draft = 'Draft',
  Hold = 'Hold',
  Suspended = 'Suspended'
}

export type Sfx = {
  __typename?: 'Sfx';
  code?: Maybe<Scalars['String']>;
  subSfxs?: Maybe<Array<Maybe<SubItems>>>;
};

export type StreamUrl = {
  __typename?: 'StreamUrl';
  url?: Maybe<Scalars['String']>;
};

export type SubItems = {
  __typename?: 'SubItems';
  code?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onUserCreditsUpdated: Scalars['Boolean'];
};

export type SubscriptionPlanProductDetails = {
  __typename?: 'SubscriptionPlanProductDetails';
  code: Scalars['String'];
  currentQuantity: Scalars['Float'];
  endDate?: Maybe<Scalars['String']>;
  isUnlimited: Scalars['Boolean'];
  maxQuantity?: Maybe<Scalars['Float']>;
  numberOfCredits?: Maybe<Scalars['Int']>;
  status: SubscriptionProductStatus;
};

export enum SubscriptionProductStatus {
  Active = 'Active',
  Expired = 'Expired'
}

export enum SubscriptionStatusEnum {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Draft = 'Draft',
  PendingPlanChange = 'PendingPlanChange',
  Suspended = 'Suspended'
}

export type Tag = {
  __typename?: 'Tag';
  code?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
};

export type Track = {
  __typename?: 'Track';
  bpm?: Maybe<Scalars['Int']>;
  bpmMultiplier?: Maybe<BpmMultiplier>;
  gain?: Maybe<Scalars['Int']>;
  guid: Scalars['ID'];
  pitchTranspose?: Maybe<Scalars['Int']>;
};

export type TrackInput = {
  bpm?: InputMaybe<Scalars['Int']>;
  bpmMultiplier?: InputMaybe<BpmMultiplier>;
  gain?: InputMaybe<Scalars['Int']>;
  guid: Scalars['ID'];
  pitchTranspose?: InputMaybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  country?: Maybe<Scalars['String']>;
  creationTime: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  experience?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  hasSeenArchiveNotification: Scalars['Boolean'];
  homePage: HomePageEnum;
  isArchived: Scalars['Boolean'];
  lastname?: Maybe<Scalars['String']>;
  musicGenres?: Maybe<Array<Maybe<MusicGenre>>>;
  permalink?: Maybe<Scalars['String']>;
  preferredCulture?: Maybe<Scalars['String']>;
  primaryOccupation?: Maybe<OccupationEnum>;
  profilePicture72Url?: Maybe<Scalars['String']>;
  profilePicture360Url?: Maybe<Scalars['String']>;
  secondaryOccupations?: Maybe<Array<Maybe<OccupationEnum>>>;
  signupCountry?: Maybe<Scalars['String']>;
  signupCountryCode?: Maybe<Scalars['String']>;
  signupState?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type UserCollection = {
  __typename?: 'UserCollection';
  artworkUrl?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['String']>;
  guid?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  sampleCount?: Maybe<Scalars['Int']>;
  seoMetadata?: Maybe<SeoMetadata>;
  slug?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export type UserCollectionsFeed = {
  __typename?: 'UserCollectionsFeed';
  feed?: Maybe<Array<Maybe<UserCollection>>>;
  meta?: Maybe<MetaPage>;
};


export type UserCollectionsFeedFeedArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type UserCredits = {
  __typename?: 'UserCredits';
  remaining?: Maybe<Scalars['Int']>;
};

export type UserRecentSearch = {
  __typename?: 'UserRecentSearch';
  filterSlug: Scalars['String'];
  searchFilter: UserSearchFilter;
};

export type UserRecentSearches = {
  __typename?: 'UserRecentSearches';
  recentSearch: Array<UserRecentSearch>;
};

export enum UserSearchFilter {
  Descriptors = 'Descriptors',
  Genres = 'Genres',
  Instruments = 'Instruments',
  Sfxs = 'Sfxs',
  Tags = 'Tags',
  Textsearch = 'Textsearch'
}

export type Waveform = {
  __typename?: 'Waveform';
  guid: Scalars['ID'];
  waveform: Array<Maybe<Scalars['Float']>>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AbstractCuratedList: ResolverTypeWrapper<AbstractCuratedList>;
  AbstractCuratedListPage: ResolverTypeWrapper<AbstractCuratedListPage>;
  AcceptUserAgreementsInput: AcceptUserAgreementsInput;
  AccountBalanceSummary: ResolverTypeWrapper<AccountBalanceSummary>;
  AccountStatusEnum: AccountStatusEnum;
  Agreement: ResolverTypeWrapper<Agreement>;
  Agreements: ResolverTypeWrapper<Agreements>;
  AllSubscriptions: ResolverTypeWrapper<AllSubscriptions>;
  AlternateLanguage: ResolverTypeWrapper<AlternateLanguage>;
  Artist: ResolverTypeWrapper<Artist>;
  Balance: ResolverTypeWrapper<Balance>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  BpmMultiplier: BpmMultiplier;
  Collection: ResolverTypeWrapper<Collection>;
  ContentGroup: ResolverTypeWrapper<ContentGroup>;
  ContentList: ResolverTypeWrapper<Omit<ContentList, 'items'> & { items: Array<Maybe<ResolversTypes['ContentListItem']>> }>;
  ContentListItem: ResolversTypes['Pack'] | ResolversTypes['Repack'];
  ContentTarget: ContentTarget;
  CostPreviewResponse: ResolverTypeWrapper<CostPreviewResponse>;
  CreatorSession: ResolverTypeWrapper<CreatorSession>;
  CreatorSessionInput: CreatorSessionInput;
  CreditBalancePayloadType: ResolverTypeWrapper<CreditBalancePayloadType>;
  CuratedList: ResolverTypeWrapper<Omit<CuratedList, 'data'> & { data: Array<ResolversTypes['CuratedListDataType']> }>;
  CuratedListDataType: ResolversTypes['Artist'] | ResolversTypes['Genre'] | ResolversTypes['Instrument'] | ResolversTypes['Label'] | ResolversTypes['Pack'] | ResolversTypes['Repack'] | ResolversTypes['Sample'];
  CuratedListFeed: ResolverTypeWrapper<Omit<CuratedListFeed, 'feed'> & { feed?: Maybe<Array<Maybe<ResolversTypes['CuratedListDataType']>>> }>;
  CuratedListGroup: ResolverTypeWrapper<CuratedListGroup>;
  CuratedListMeta: ResolverTypeWrapper<CuratedListMeta>;
  CuratedListPage: ResolverTypeWrapper<CuratedListPage>;
  CuratedListType: CuratedListType;
  CurrentSubscription: ResolverTypeWrapper<CurrentSubscription>;
  Date: ResolverTypeWrapper<Scalars['Date']>;
  Descriptor: ResolverTypeWrapper<Descriptor>;
  FilterMeta: ResolverTypeWrapper<FilterMeta>;
  Filters: ResolverTypeWrapper<Filters>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  Genre: ResolverTypeWrapper<Genre>;
  GenreInput: GenreInput;
  HeroBanner: ResolverTypeWrapper<Omit<HeroBanner, 'entity'> & { entity: ResolversTypes['HeroBannerEntityType'] }>;
  HeroBannerContentType: HeroBannerContentType;
  HeroBannerEntityType: ResolversTypes['Label'] | ResolversTypes['Pack'] | ResolversTypes['Repack'];
  HomePageEnum: HomePageEnum;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  Instrument: ResolverTypeWrapper<Instrument>;
  InstrumentInput: InstrumentInput;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  Interval: Interval;
  Key: ResolverTypeWrapper<Key>;
  KeyInput: KeyInput;
  KeyQuality: KeyQuality;
  KeyRootApi: KeyRootApi;
  KeySign: KeySign;
  Label: ResolverTypeWrapper<Label>;
  LabelsChart: ResolverTypeWrapper<LabelsChart>;
  LabelsChartItem: ResolverTypeWrapper<LabelsChartItem>;
  LegalAgreementKindEnum: LegalAgreementKindEnum;
  Locale: Locale;
  MerchZone: ResolverTypeWrapper<MerchZone>;
  MetaPage: ResolverTypeWrapper<MetaPage>;
  MusicGenre: MusicGenre;
  Mutation: ResolverTypeWrapper<{}>;
  NextPage: ResolverTypeWrapper<NextPage>;
  OccupationEnum: OccupationEnum;
  OverduePayment: ResolverTypeWrapper<OverduePayment>;
  Pack: ResolverTypeWrapper<Pack>;
  PackFavoritedInput: PackFavoritedInput;
  PackState: PackState;
  PackType: PackType;
  PackagesMeta: ResolverTypeWrapper<PackagesMeta>;
  PacksChart: ResolverTypeWrapper<PacksChart>;
  PacksChartItem: ResolverTypeWrapper<PacksChartItem>;
  PacksOrRepacks: ResolversTypes['Pack'] | ResolversTypes['Repack'];
  PaginatedArtists: ResolverTypeWrapper<PaginatedArtists>;
  PaginatedLabels: ResolverTypeWrapper<PaginatedLabels>;
  PaginatedPacks: ResolverTypeWrapper<PaginatedPacks>;
  PaginatedPacksOrRepacks: ResolverTypeWrapper<Omit<PaginatedPacksOrRepacks, 'data'> & { data?: Maybe<Array<Maybe<ResolversTypes['PacksOrRepacks']>>> }>;
  PaginatedRepacks: ResolverTypeWrapper<PaginatedRepacks>;
  PaginatedSamples: ResolverTypeWrapper<PaginatedSamples>;
  PaginatedUserCollections: ResolverTypeWrapper<PaginatedUserCollections>;
  PlanFrequencyIdentifier: ResolverTypeWrapper<PlanFrequencyIdentifier>;
  PluginPackages: ResolverTypeWrapper<PluginPackages>;
  PremiumCodes: PremiumCodes;
  PrismicBackgroundImage: ResolverTypeWrapper<PrismicBackgroundImage>;
  PrismicBanner: ResolverTypeWrapper<PrismicBanner>;
  PrismicBannerData: ResolversTypes['PrismicSampleAuthBannerData'] | ResolversTypes['PrismicSampleBannerData'] | ResolversTypes['PrismicSampleBannerGroupData'];
  PrismicDocument: ResolverTypeWrapper<Omit<PrismicDocument, 'data'> & { data: ResolversTypes['PrismicBannerData'] }>;
  PrismicImage: ResolverTypeWrapper<PrismicImage>;
  PrismicImageDimensions: ResolverTypeWrapper<PrismicImageDimensions>;
  PrismicSampleAuthBannerCtaLink: ResolverTypeWrapper<PrismicSampleAuthBannerCtaLink>;
  PrismicSampleAuthBannerCtaText: ResolverTypeWrapper<PrismicSampleAuthBannerCtaText>;
  PrismicSampleAuthBannerData: ResolverTypeWrapper<PrismicSampleAuthBannerData>;
  PrismicSampleAuthBannerDescription: ResolverTypeWrapper<PrismicSampleAuthBannerDescription>;
  PrismicSampleAuthBannerTitle: ResolverTypeWrapper<PrismicSampleAuthBannerTitle>;
  PrismicSampleBannerData: ResolverTypeWrapper<PrismicSampleBannerData>;
  PrismicSampleBannerGroupData: ResolverTypeWrapper<PrismicSampleBannerGroupData>;
  PrismicTextField: ResolverTypeWrapper<PrismicTextField>;
  PromotionalCard: ResolverTypeWrapper<PromotionalCard>;
  PromotionalCardType: PromotionalCardType;
  ProviderType: ProviderType;
  PurchasableCreatorSample: PurchasableCreatorSample;
  PurchasableCreatorSession: PurchasableCreatorSession;
  PurchaseResponse: ResolverTypeWrapper<PurchaseResponse>;
  Query: ResolverTypeWrapper<{}>;
  Repack: ResolverTypeWrapper<Repack>;
  RepackFavoritedInput: RepackFavoritedInput;
  RepackSubType: RepackSubType;
  RepacksChart: ResolverTypeWrapper<RepacksChart>;
  RepacksChartItem: ResolverTypeWrapper<RepacksChartItem>;
  Sample: ResolverTypeWrapper<Sample>;
  SampleFavoritedInput: SampleFavoritedInput;
  SampleKey: ResolverTypeWrapper<SampleKey>;
  SampleKeyInput: SampleKeyInput;
  SampleState: SampleState;
  SampleType: SampleType;
  Seo: ResolverTypeWrapper<Seo>;
  SeoItem: ResolverTypeWrapper<SeoItem>;
  SeoMetadata: ResolverTypeWrapper<SeoMetadata>;
  SeoMetadataInput: SeoMetadataInput;
  ServiceOfferKind: ServiceOfferKind;
  ServiceStatusEnum: ServiceStatusEnum;
  Sfx: ResolverTypeWrapper<Sfx>;
  StreamUrl: ResolverTypeWrapper<StreamUrl>;
  String: ResolverTypeWrapper<Scalars['String']>;
  SubItems: ResolverTypeWrapper<SubItems>;
  Subscription: ResolverTypeWrapper<{}>;
  SubscriptionPlanProductDetails: ResolverTypeWrapper<SubscriptionPlanProductDetails>;
  SubscriptionProductStatus: SubscriptionProductStatus;
  SubscriptionStatusEnum: SubscriptionStatusEnum;
  Tag: ResolverTypeWrapper<Tag>;
  Track: ResolverTypeWrapper<Track>;
  TrackInput: TrackInput;
  User: ResolverTypeWrapper<User>;
  UserCollection: ResolverTypeWrapper<UserCollection>;
  UserCollectionsFeed: ResolverTypeWrapper<UserCollectionsFeed>;
  UserCredits: ResolverTypeWrapper<UserCredits>;
  UserRecentSearch: ResolverTypeWrapper<UserRecentSearch>;
  UserRecentSearches: ResolverTypeWrapper<UserRecentSearches>;
  UserSearchFilter: UserSearchFilter;
  Waveform: ResolverTypeWrapper<Waveform>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AbstractCuratedList: AbstractCuratedList;
  AbstractCuratedListPage: AbstractCuratedListPage;
  AcceptUserAgreementsInput: AcceptUserAgreementsInput;
  AccountBalanceSummary: AccountBalanceSummary;
  Agreement: Agreement;
  Agreements: Agreements;
  AllSubscriptions: AllSubscriptions;
  AlternateLanguage: AlternateLanguage;
  Artist: Artist;
  Balance: Balance;
  Boolean: Scalars['Boolean'];
  Collection: Collection;
  ContentGroup: ContentGroup;
  ContentList: Omit<ContentList, 'items'> & { items: Array<Maybe<ResolversParentTypes['ContentListItem']>> };
  ContentListItem: ResolversParentTypes['Pack'] | ResolversParentTypes['Repack'];
  CostPreviewResponse: CostPreviewResponse;
  CreatorSession: CreatorSession;
  CreatorSessionInput: CreatorSessionInput;
  CreditBalancePayloadType: CreditBalancePayloadType;
  CuratedList: Omit<CuratedList, 'data'> & { data: Array<ResolversParentTypes['CuratedListDataType']> };
  CuratedListDataType: ResolversParentTypes['Artist'] | ResolversParentTypes['Genre'] | ResolversParentTypes['Instrument'] | ResolversParentTypes['Label'] | ResolversParentTypes['Pack'] | ResolversParentTypes['Repack'] | ResolversParentTypes['Sample'];
  CuratedListFeed: Omit<CuratedListFeed, 'feed'> & { feed?: Maybe<Array<Maybe<ResolversParentTypes['CuratedListDataType']>>> };
  CuratedListGroup: CuratedListGroup;
  CuratedListMeta: CuratedListMeta;
  CuratedListPage: CuratedListPage;
  CurrentSubscription: CurrentSubscription;
  Date: Scalars['Date'];
  Descriptor: Descriptor;
  FilterMeta: FilterMeta;
  Filters: Filters;
  Float: Scalars['Float'];
  Genre: Genre;
  GenreInput: GenreInput;
  HeroBanner: Omit<HeroBanner, 'entity'> & { entity: ResolversParentTypes['HeroBannerEntityType'] };
  HeroBannerEntityType: ResolversParentTypes['Label'] | ResolversParentTypes['Pack'] | ResolversParentTypes['Repack'];
  ID: Scalars['ID'];
  Instrument: Instrument;
  InstrumentInput: InstrumentInput;
  Int: Scalars['Int'];
  Key: Key;
  KeyInput: KeyInput;
  Label: Label;
  LabelsChart: LabelsChart;
  LabelsChartItem: LabelsChartItem;
  MerchZone: MerchZone;
  MetaPage: MetaPage;
  Mutation: {};
  NextPage: NextPage;
  OverduePayment: OverduePayment;
  Pack: Pack;
  PackFavoritedInput: PackFavoritedInput;
  PackagesMeta: PackagesMeta;
  PacksChart: PacksChart;
  PacksChartItem: PacksChartItem;
  PacksOrRepacks: ResolversParentTypes['Pack'] | ResolversParentTypes['Repack'];
  PaginatedArtists: PaginatedArtists;
  PaginatedLabels: PaginatedLabels;
  PaginatedPacks: PaginatedPacks;
  PaginatedPacksOrRepacks: Omit<PaginatedPacksOrRepacks, 'data'> & { data?: Maybe<Array<Maybe<ResolversParentTypes['PacksOrRepacks']>>> };
  PaginatedRepacks: PaginatedRepacks;
  PaginatedSamples: PaginatedSamples;
  PaginatedUserCollections: PaginatedUserCollections;
  PlanFrequencyIdentifier: PlanFrequencyIdentifier;
  PluginPackages: PluginPackages;
  PrismicBackgroundImage: PrismicBackgroundImage;
  PrismicBanner: PrismicBanner;
  PrismicBannerData: ResolversParentTypes['PrismicSampleAuthBannerData'] | ResolversParentTypes['PrismicSampleBannerData'] | ResolversParentTypes['PrismicSampleBannerGroupData'];
  PrismicDocument: Omit<PrismicDocument, 'data'> & { data: ResolversParentTypes['PrismicBannerData'] };
  PrismicImage: PrismicImage;
  PrismicImageDimensions: PrismicImageDimensions;
  PrismicSampleAuthBannerCtaLink: PrismicSampleAuthBannerCtaLink;
  PrismicSampleAuthBannerCtaText: PrismicSampleAuthBannerCtaText;
  PrismicSampleAuthBannerData: PrismicSampleAuthBannerData;
  PrismicSampleAuthBannerDescription: PrismicSampleAuthBannerDescription;
  PrismicSampleAuthBannerTitle: PrismicSampleAuthBannerTitle;
  PrismicSampleBannerData: PrismicSampleBannerData;
  PrismicSampleBannerGroupData: PrismicSampleBannerGroupData;
  PrismicTextField: PrismicTextField;
  PromotionalCard: PromotionalCard;
  PurchasableCreatorSample: PurchasableCreatorSample;
  PurchasableCreatorSession: PurchasableCreatorSession;
  PurchaseResponse: PurchaseResponse;
  Query: {};
  Repack: Repack;
  RepackFavoritedInput: RepackFavoritedInput;
  RepacksChart: RepacksChart;
  RepacksChartItem: RepacksChartItem;
  Sample: Sample;
  SampleFavoritedInput: SampleFavoritedInput;
  SampleKey: SampleKey;
  SampleKeyInput: SampleKeyInput;
  Seo: Seo;
  SeoItem: SeoItem;
  SeoMetadata: SeoMetadata;
  SeoMetadataInput: SeoMetadataInput;
  Sfx: Sfx;
  StreamUrl: StreamUrl;
  String: Scalars['String'];
  SubItems: SubItems;
  Subscription: {};
  SubscriptionPlanProductDetails: SubscriptionPlanProductDetails;
  Tag: Tag;
  Track: Track;
  TrackInput: TrackInput;
  User: User;
  UserCollection: UserCollection;
  UserCollectionsFeed: UserCollectionsFeed;
  UserCredits: UserCredits;
  UserRecentSearch: UserRecentSearch;
  UserRecentSearches: UserRecentSearches;
  Waveform: Waveform;
};

export type AbstractCuratedListResolvers<ContextType = any, ParentType extends ResolversParentTypes['AbstractCuratedList'] = ResolversParentTypes['AbstractCuratedList']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CuratedListType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AbstractCuratedListPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AbstractCuratedListPage'] = ResolversParentTypes['AbstractCuratedListPage']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['AbstractCuratedList']>>>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['MetaPage']>, ParentType, ContextType>;
  next?: Resolver<Maybe<ResolversTypes['NextPage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountBalanceSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountBalanceSummary'] = ResolversParentTypes['AccountBalanceSummary']> = {
  accountingStatus?: Resolver<ResolversTypes['AccountStatusEnum'], ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencySymbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  overduePayments?: Resolver<Array<ResolversTypes['OverduePayment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Agreement'] = ResolversParentTypes['Agreement']> = {
  kind?: Resolver<ResolversTypes['LegalAgreementKindEnum'], ParentType, ContextType>;
  requireUpdate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Agreements'] = ResolversParentTypes['Agreements']> = {
  agreements?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agreement']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AllSubscriptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllSubscriptions'] = ResolversParentTypes['AllSubscriptions']> = {
  subscriptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CurrentSubscription']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlternateLanguageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlternateLanguage'] = ResolversParentTypes['AlternateLanguage']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lang?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ArtistResolvers<ContextType = any, ParentType extends ResolversParentTypes['Artist'] = ResolversParentTypes['Artist']> = {
  artworkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coverUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isExclusive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  portraitUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seoMetadata?: Resolver<Maybe<ResolversTypes['SeoMetadata']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Balance'] = ResolversParentTypes['Balance']> = {
  balance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Collection'] = ResolversParentTypes['Collection']> = {
  artworkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDownloaded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isExclusive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFavorited?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFree?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subType?: Resolver<ResolversTypes['RepackSubType'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PackType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentGroup'] = ResolversParentTypes['ContentGroup']> = {
  byline?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contentLists?: Resolver<Array<Maybe<ResolversTypes['ContentList']>>, ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  target?: Resolver<ResolversTypes['ContentTarget'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentList'] = ResolversParentTypes['ContentList']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['ContentListItem']>>, ParentType, ContextType>;
  tabName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentListItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentListItem'] = ResolversParentTypes['ContentListItem']> = {
  __resolveType: TypeResolveFn<'Pack' | 'Repack', ParentType, ContextType>;
};

export type CostPreviewResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CostPreviewResponse'] = ResolversParentTypes['CostPreviewResponse']> = {
  credits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  remainingCredits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreatorSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatorSession'] = ResolversParentTypes['CreatorSession']> = {
  bpm?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPublic?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['Key']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  samples?: Resolver<Maybe<Array<Maybe<ResolversTypes['Track']>>>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreditBalancePayloadTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreditBalancePayloadType'] = ResolversParentTypes['CreditBalancePayloadType']> = {
  hdwav?: Resolver<Maybe<ResolversTypes['Balance']>, ParentType, ContextType>;
  mp3?: Resolver<Maybe<ResolversTypes['Balance']>, ParentType, ContextType>;
  sample?: Resolver<Maybe<ResolversTypes['Balance']>, ParentType, ContextType>;
  wav?: Resolver<Maybe<ResolversTypes['Balance']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CuratedListResolvers<ContextType = any, ParentType extends ResolversParentTypes['CuratedList'] = ResolversParentTypes['CuratedList']> = {
  browseUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  data?: Resolver<Array<ResolversTypes['CuratedListDataType']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CuratedListType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CuratedListDataTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CuratedListDataType'] = ResolversParentTypes['CuratedListDataType']> = {
  __resolveType: TypeResolveFn<'Artist' | 'Genre' | 'Instrument' | 'Label' | 'Pack' | 'Repack' | 'Sample', ParentType, ContextType>;
};

export type CuratedListFeedResolvers<ContextType = any, ParentType extends ResolversParentTypes['CuratedListFeed'] = ResolversParentTypes['CuratedListFeed']> = {
  feed?: Resolver<Maybe<Array<Maybe<ResolversTypes['CuratedListDataType']>>>, ParentType, ContextType, RequireFields<CuratedListFeedFeedArgs, 'slug' | 'type'>>;
  meta?: Resolver<Maybe<ResolversTypes['CuratedListMeta']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CuratedListGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['CuratedListGroup'] = ResolversParentTypes['CuratedListGroup']> = {
  code?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  curatedLists?: Resolver<Maybe<ResolversTypes['AbstractCuratedListPage']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CuratedListMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['CuratedListMeta'] = ResolversParentTypes['CuratedListMeta']> = {
  browseUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['MetaPage']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CuratedListType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CuratedListPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['CuratedListPage'] = ResolversParentTypes['CuratedListPage']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['CuratedList']>>>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['MetaPage']>, ParentType, ContextType>;
  next?: Resolver<Maybe<ResolversTypes['NextPage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentSubscription'] = ResolversParentTypes['CurrentSubscription']> = {
  activationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creationDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nextPeriodStartDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plan?: Resolver<ResolversTypes['PlanFrequencyIdentifier'], ParentType, ContextType>;
  segment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceOffer?: Resolver<ResolversTypes['ServiceOfferKind'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SubscriptionStatusEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export type DescriptorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Descriptor'] = ResolversParentTypes['Descriptor']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilterMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['FilterMeta'] = ResolversParentTypes['FilterMeta']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FiltersResolvers<ContextType = any, ParentType extends ResolversParentTypes['Filters'] = ResolversParentTypes['Filters']> = {
  descriptorFilters?: Resolver<Maybe<Array<Maybe<ResolversTypes['FilterMeta']>>>, ParentType, ContextType>;
  genreFilters?: Resolver<Maybe<Array<Maybe<ResolversTypes['FilterMeta']>>>, ParentType, ContextType>;
  instrumentFilters?: Resolver<Maybe<Array<Maybe<ResolversTypes['FilterMeta']>>>, ParentType, ContextType>;
  sampleTypeFilters?: Resolver<Maybe<Array<Maybe<ResolversTypes['FilterMeta']>>>, ParentType, ContextType>;
  sfxFilters?: Resolver<Maybe<Array<Maybe<ResolversTypes['FilterMeta']>>>, ParentType, ContextType>;
  tagFilters?: Resolver<Maybe<Array<Maybe<ResolversTypes['FilterMeta']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenreResolvers<ContextType = any, ParentType extends ResolversParentTypes['Genre'] = ResolversParentTypes['Genre']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subGenres?: Resolver<Maybe<Array<Maybe<ResolversTypes['Genre']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HeroBannerResolvers<ContextType = any, ParentType extends ResolversParentTypes['HeroBanner'] = ResolversParentTypes['HeroBanner']> = {
  byline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['HeroBannerContentType'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entity?: Resolver<ResolversTypes['HeroBannerEntityType'], ParentType, ContextType>;
  genres?: Resolver<Maybe<Array<Maybe<ResolversTypes['Genre']>>>, ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  instruments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Instrument']>>>, ParentType, ContextType>;
  labelPacks?: Resolver<Maybe<Array<Maybe<ResolversTypes['Pack']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HeroBannerEntityTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['HeroBannerEntityType'] = ResolversParentTypes['HeroBannerEntityType']> = {
  __resolveType: TypeResolveFn<'Label' | 'Pack' | 'Repack', ParentType, ContextType>;
};

export type InstrumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Instrument'] = ResolversParentTypes['Instrument']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isFamily?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  subInstruments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Instrument']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KeyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Key'] = ResolversParentTypes['Key']> = {
  quality?: Resolver<Maybe<ResolversTypes['KeyQuality']>, ParentType, ContextType>;
  root?: Resolver<Maybe<ResolversTypes['KeyRootApi']>, ParentType, ContextType>;
  sign?: Resolver<Maybe<ResolversTypes['KeySign']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LabelResolvers<ContextType = any, ParentType extends ResolversParentTypes['Label'] = ResolversParentTypes['Label']> = {
  artworkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coverUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isExclusive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sampleCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seoMetadata?: Resolver<Maybe<ResolversTypes['SeoMetadata']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LabelsChartResolvers<ContextType = any, ParentType extends ResolversParentTypes['LabelsChart'] = ResolversParentTypes['LabelsChart']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['LabelsChartItem']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LabelsChartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LabelsChartItem'] = ResolversParentTypes['LabelsChartItem']> = {
  artistName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  artworkUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currentRank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isNew?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subItemsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MerchZoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchZone'] = ResolversParentTypes['MerchZone']> = {
  contentGroups?: Resolver<Array<ResolversTypes['ContentGroup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetaPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetaPage'] = ResolversParentTypes['MetaPage']> = {
  filters?: Resolver<Maybe<ResolversTypes['Filters']>, ParentType, ContextType>;
  totalPackRecords?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalRecords?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalRepackRecords?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalSampleRecords?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptUserAgreements?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationAcceptUserAgreementsArgs, 'agreements'>>;
  addSamplesToUserCollection?: Resolver<Maybe<ResolversTypes['UserCollection']>, ParentType, ContextType, Partial<MutationAddSamplesToUserCollectionArgs>>;
  createUserCollection?: Resolver<Maybe<ResolversTypes['UserCollection']>, ParentType, ContextType, Partial<MutationCreateUserCollectionArgs>>;
  createUserRecentSearch?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationCreateUserRecentSearchArgs, 'filterSlug' | 'filterType'>>;
  deleteUserCollection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<MutationDeleteUserCollectionArgs>>;
  deleteUserRecentSearch?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDeleteUserRecentSearchArgs, 'filterSlug' | 'filterType'>>;
  editUserCollection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<MutationEditUserCollectionArgs>>;
  putMilestones?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationPutMilestonesArgs, 'milestones'>>;
  removeSamplesFromUserCollection?: Resolver<Maybe<ResolversTypes['UserCollection']>, ParentType, ContextType, Partial<MutationRemoveSamplesFromUserCollectionArgs>>;
  storeCreatorSession?: Resolver<Maybe<ResolversTypes['CreatorSession']>, ParentType, ContextType, Partial<MutationStoreCreatorSessionArgs>>;
  updatePackFavoritedState?: Resolver<Maybe<ResolversTypes['Pack']>, ParentType, ContextType, RequireFields<MutationUpdatePackFavoritedStateArgs, 'pack'>>;
  updateRepackFavoritedState?: Resolver<Maybe<ResolversTypes['Repack']>, ParentType, ContextType, RequireFields<MutationUpdateRepackFavoritedStateArgs, 'repack'>>;
  updateSampleFavoritedState?: Resolver<Maybe<ResolversTypes['Sample']>, ParentType, ContextType, RequireFields<MutationUpdateSampleFavoritedStateArgs, 'sample'>>;
};

export type NextPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['NextPage'] = ResolversParentTypes['NextPage']> = {
  skip?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OverduePaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OverduePayment'] = ResolversParentTypes['OverduePayment']> = {
  serviceOffer?: Resolver<ResolversTypes['ServiceOfferKind'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PackResolvers<ContextType = any, ParentType extends ResolversParentTypes['Pack'] = ResolversParentTypes['Pack']> = {
  artist?: Resolver<Maybe<ResolversTypes['Artist']>, ParentType, ContextType>;
  artworkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorSession?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  foregroundColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genres?: Resolver<Maybe<Array<Maybe<ResolversTypes['Genre']>>>, ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isDownloaded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isExclusive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFavorited?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFree?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['Label']>, ParentType, ContextType>;
  mainGenre?: Resolver<Maybe<ResolversTypes['Genre']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packState?: Resolver<ResolversTypes['PackState'], ParentType, ContextType>;
  premiumCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['PremiumCodes']>>>, ParentType, ContextType>;
  sampleCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seoMetadata?: Resolver<Maybe<ResolversTypes['SeoMetadata']>, ParentType, ContextType>;
  sfxs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Sfx']>>>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PackType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PackagesMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['PackagesMeta'] = ResolversParentTypes['PackagesMeta']> = {
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PacksChartResolvers<ContextType = any, ParentType extends ResolversParentTypes['PacksChart'] = ResolversParentTypes['PacksChart']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['PacksChartItem']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PacksChartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PacksChartItem'] = ResolversParentTypes['PacksChartItem']> = {
  artistName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  artworkUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currentRank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isNew?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subItemsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PacksOrRepacksResolvers<ContextType = any, ParentType extends ResolversParentTypes['PacksOrRepacks'] = ResolversParentTypes['PacksOrRepacks']> = {
  __resolveType: TypeResolveFn<'Pack' | 'Repack', ParentType, ContextType>;
};

export type PaginatedArtistsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedArtists'] = ResolversParentTypes['PaginatedArtists']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['Artist']>>>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['MetaPage']>, ParentType, ContextType>;
  next?: Resolver<Maybe<ResolversTypes['NextPage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedLabelsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedLabels'] = ResolversParentTypes['PaginatedLabels']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['Label']>>>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['MetaPage']>, ParentType, ContextType>;
  next?: Resolver<Maybe<ResolversTypes['NextPage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedPacksResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedPacks'] = ResolversParentTypes['PaginatedPacks']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['Pack']>>>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['MetaPage']>, ParentType, ContextType>;
  next?: Resolver<Maybe<ResolversTypes['NextPage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedPacksOrRepacksResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedPacksOrRepacks'] = ResolversParentTypes['PaginatedPacksOrRepacks']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['PacksOrRepacks']>>>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['MetaPage']>, ParentType, ContextType>;
  next?: Resolver<Maybe<ResolversTypes['NextPage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedRepacksResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedRepacks'] = ResolversParentTypes['PaginatedRepacks']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['Repack']>>>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['MetaPage']>, ParentType, ContextType>;
  next?: Resolver<Maybe<ResolversTypes['NextPage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedSamplesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedSamples'] = ResolversParentTypes['PaginatedSamples']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['Sample']>>>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['MetaPage']>, ParentType, ContextType>;
  next?: Resolver<Maybe<ResolversTypes['NextPage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedUserCollectionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedUserCollections'] = ResolversParentTypes['PaginatedUserCollections']> = {
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserCollection']>>>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['MetaPage']>, ParentType, ContextType>;
  next?: Resolver<Maybe<ResolversTypes['NextPage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlanFrequencyIdentifierResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlanFrequencyIdentifier'] = ResolversParentTypes['PlanFrequencyIdentifier']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  frequency?: Resolver<Maybe<ResolversTypes['Interval']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PluginPackagesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PluginPackages'] = ResolversParentTypes['PluginPackages']> = {
  macOS?: Resolver<Maybe<ResolversTypes['PackagesMeta']>, ParentType, ContextType>;
  windows?: Resolver<Maybe<ResolversTypes['PackagesMeta']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrismicBackgroundImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicBackgroundImage'] = ResolversParentTypes['PrismicBackgroundImage']> = {
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dimensions?: Resolver<ResolversTypes['PrismicImageDimensions'], ParentType, ContextType>;
  regular?: Resolver<ResolversTypes['PrismicImage'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrismicBannerResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicBanner'] = ResolversParentTypes['PrismicBanner']> = {
  first_publication_date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isBroken?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lang?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  last_publication_date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  link_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tags?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrismicBannerDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicBannerData'] = ResolversParentTypes['PrismicBannerData']> = {
  __resolveType: TypeResolveFn<'PrismicSampleAuthBannerData' | 'PrismicSampleBannerData' | 'PrismicSampleBannerGroupData', ParentType, ContextType>;
};

export type PrismicDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicDocument'] = ResolversParentTypes['PrismicDocument']> = {
  alternate_languages?: Resolver<Array<Maybe<ResolversTypes['AlternateLanguage']>>, ParentType, ContextType>;
  data?: Resolver<ResolversTypes['PrismicBannerData'], ParentType, ContextType>;
  first_publication_date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  href?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lang?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  last_publication_date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slugs?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  tags?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrismicImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicImage'] = ResolversParentTypes['PrismicImage']> = {
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dimensions?: Resolver<ResolversTypes['PrismicImageDimensions'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrismicImageDimensionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicImageDimensions'] = ResolversParentTypes['PrismicImageDimensions']> = {
  height?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  width?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrismicSampleAuthBannerCtaLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicSampleAuthBannerCtaLink'] = ResolversParentTypes['PrismicSampleAuthBannerCtaLink']> = {
  authenticated_cta_link?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  guest_cta_link?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrismicSampleAuthBannerCtaTextResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicSampleAuthBannerCtaText'] = ResolversParentTypes['PrismicSampleAuthBannerCtaText']> = {
  authenticated_cta_text?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  guest_cta_text?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrismicSampleAuthBannerDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicSampleAuthBannerData'] = ResolversParentTypes['PrismicSampleAuthBannerData']> = {
  background_image?: Resolver<ResolversTypes['PrismicBackgroundImage'], ParentType, ContextType>;
  banner_title?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  cta_link?: Resolver<Array<ResolversTypes['PrismicSampleAuthBannerCtaLink']>, ParentType, ContextType>;
  cta_text?: Resolver<Array<ResolversTypes['PrismicSampleAuthBannerCtaText']>, ParentType, ContextType>;
  description?: Resolver<Array<ResolversTypes['PrismicSampleAuthBannerDescription']>, ParentType, ContextType>;
  title?: Resolver<Array<ResolversTypes['PrismicSampleAuthBannerTitle']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrismicSampleAuthBannerDescriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicSampleAuthBannerDescription'] = ResolversParentTypes['PrismicSampleAuthBannerDescription']> = {
  authenticated_description?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  guest_description?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrismicSampleAuthBannerTitleResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicSampleAuthBannerTitle'] = ResolversParentTypes['PrismicSampleAuthBannerTitle']> = {
  authenticated_title?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  guest_title?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrismicSampleBannerDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicSampleBannerData'] = ResolversParentTypes['PrismicSampleBannerData']> = {
  background_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  background_image?: Resolver<ResolversTypes['PrismicBackgroundImage'], ParentType, ContextType>;
  banner_title?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  cta_path?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  cta_text?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  description?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  title?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrismicSampleBannerGroupDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicSampleBannerGroupData'] = ResolversParentTypes['PrismicSampleBannerGroupData']> = {
  banner_a?: Resolver<ResolversTypes['PrismicBanner'], ParentType, ContextType>;
  banner_b?: Resolver<ResolversTypes['PrismicBanner'], ParentType, ContextType>;
  banner_c?: Resolver<ResolversTypes['PrismicBanner'], ParentType, ContextType>;
  banner_d?: Resolver<ResolversTypes['PrismicBanner'], ParentType, ContextType>;
  banner_e?: Resolver<ResolversTypes['PrismicBanner'], ParentType, ContextType>;
  title?: Resolver<Array<ResolversTypes['PrismicTextField']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrismicTextFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrismicTextField'] = ResolversParentTypes['PrismicTextField']> = {
  spans?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotionalCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotionalCard'] = ResolversParentTypes['PromotionalCard']> = {
  backgroundColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ctaText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ctaUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageHoverUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isPrioritized?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PromotionalCardType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseResponse'] = ResolversParentTypes['PurchaseResponse']> = {
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  accountBalanceSummary?: Resolver<Maybe<ResolversTypes['AccountBalanceSummary']>, ParentType, ContextType>;
  artistBySlug?: Resolver<Maybe<ResolversTypes['Artist']>, ParentType, ContextType, Partial<QueryArtistBySlugArgs>>;
  bannerGroup?: Resolver<Array<ResolversTypes['PrismicDocument']>, ParentType, ContextType, Partial<QueryBannerGroupArgs>>;
  chartsTopLabels?: Resolver<Maybe<ResolversTypes['LabelsChart']>, ParentType, ContextType>;
  chartsTopLandrPacks?: Resolver<Maybe<ResolversTypes['RepacksChart']>, ParentType, ContextType>;
  chartsTopPacks?: Resolver<Maybe<ResolversTypes['PacksChart']>, ParentType, ContextType>;
  collectionCostPreview?: Resolver<Maybe<ResolversTypes['CostPreviewResponse']>, ParentType, ContextType, Partial<QueryCollectionCostPreviewArgs>>;
  collectionPurchase?: Resolver<Maybe<ResolversTypes['PurchaseResponse']>, ParentType, ContextType, Partial<QueryCollectionPurchaseArgs>>;
  contentGroup?: Resolver<Maybe<ResolversTypes['ContentGroup']>, ParentType, ContextType, RequireFields<QueryContentGroupArgs, 'guid'>>;
  creatorMixdownPurchase?: Resolver<Maybe<ResolversTypes['PurchaseResponse']>, ParentType, ContextType, RequireFields<QueryCreatorMixdownPurchaseArgs, 'purchasableItem'>>;
  creatorSamplesCostPreview?: Resolver<Maybe<ResolversTypes['CostPreviewResponse']>, ParentType, ContextType, Partial<QueryCreatorSamplesCostPreviewArgs>>;
  creatorSamplesPurchase?: Resolver<Maybe<ResolversTypes['PurchaseResponse']>, ParentType, ContextType, RequireFields<QueryCreatorSamplesPurchaseArgs, 'purchasableItem'>>;
  creatorSessionById?: Resolver<Maybe<ResolversTypes['CreatorSession']>, ParentType, ContextType, Partial<QueryCreatorSessionByIdArgs>>;
  curatedList?: Resolver<Maybe<ResolversTypes['CuratedList']>, ParentType, ContextType, RequireFields<QueryCuratedListArgs, 'slug' | 'type'>>;
  curatedListFeed?: Resolver<Maybe<ResolversTypes['CuratedListFeed']>, ParentType, ContextType, RequireFields<QueryCuratedListFeedArgs, 'slug' | 'type'>>;
  curatedListGroup?: Resolver<Maybe<ResolversTypes['CuratedListGroup']>, ParentType, ContextType, RequireFields<QueryCuratedListGroupArgs, 'slug'>>;
  genres?: Resolver<Maybe<Array<Maybe<ResolversTypes['Genre']>>>, ParentType, ContextType>;
  getUserRecentSearch?: Resolver<ResolversTypes['UserRecentSearches'], ParentType, ContextType>;
  heroBanners?: Resolver<Maybe<Array<Maybe<ResolversTypes['HeroBanner']>>>, ParentType, ContextType>;
  instruments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Instrument']>>>, ParentType, ContextType>;
  labelBySlug?: Resolver<Maybe<ResolversTypes['Label']>, ParentType, ContextType, Partial<QueryLabelBySlugArgs>>;
  lastCreatorSession?: Resolver<Maybe<ResolversTypes['CreatorSession']>, ParentType, ContextType>;
  merchZone?: Resolver<Maybe<ResolversTypes['MerchZone']>, ParentType, ContextType, RequireFields<QueryMerchZoneArgs, 'slug'>>;
  milestones?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  pack?: Resolver<Maybe<ResolversTypes['Pack']>, ParentType, ContextType, RequireFields<QueryPackArgs, 'packSlugOrGuid'>>;
  packCostPreview?: Resolver<Maybe<ResolversTypes['CostPreviewResponse']>, ParentType, ContextType, Partial<QueryPackCostPreviewArgs>>;
  packPurchase?: Resolver<Maybe<ResolversTypes['PurchaseResponse']>, ParentType, ContextType, Partial<QueryPackPurchaseArgs>>;
  packStream?: Resolver<Maybe<ResolversTypes['StreamUrl']>, ParentType, ContextType, RequireFields<QueryPackStreamArgs, 'packGuid'>>;
  paginatedArtistPacks?: Resolver<Maybe<ResolversTypes['PaginatedPacks']>, ParentType, ContextType, Partial<QueryPaginatedArtistPacksArgs>>;
  paginatedArtistSamples?: Resolver<Maybe<ResolversTypes['PaginatedSamples']>, ParentType, ContextType, Partial<QueryPaginatedArtistSamplesArgs>>;
  paginatedArtists?: Resolver<Maybe<ResolversTypes['PaginatedArtists']>, ParentType, ContextType, Partial<QueryPaginatedArtistsArgs>>;
  paginatedDownloadedPacksAndRepacksV2?: Resolver<Maybe<ResolversTypes['PaginatedPacksOrRepacks']>, ParentType, ContextType, Partial<QueryPaginatedDownloadedPacksAndRepacksV2Args>>;
  paginatedDownloadedSamples?: Resolver<Maybe<ResolversTypes['PaginatedSamples']>, ParentType, ContextType, Partial<QueryPaginatedDownloadedSamplesArgs>>;
  paginatedFavoritedPacksAndRepacksV2?: Resolver<Maybe<ResolversTypes['PaginatedPacksOrRepacks']>, ParentType, ContextType, Partial<QueryPaginatedFavoritedPacksAndRepacksV2Args>>;
  paginatedFavoritedSamples?: Resolver<Maybe<ResolversTypes['PaginatedSamples']>, ParentType, ContextType, Partial<QueryPaginatedFavoritedSamplesArgs>>;
  paginatedLabelPacks?: Resolver<Maybe<ResolversTypes['PaginatedPacks']>, ParentType, ContextType, Partial<QueryPaginatedLabelPacksArgs>>;
  paginatedLabelSamples?: Resolver<Maybe<ResolversTypes['PaginatedSamples']>, ParentType, ContextType, Partial<QueryPaginatedLabelSamplesArgs>>;
  paginatedLabels?: Resolver<Maybe<ResolversTypes['PaginatedLabels']>, ParentType, ContextType, Partial<QueryPaginatedLabelsArgs>>;
  paginatedPackSamples?: Resolver<Maybe<ResolversTypes['PaginatedSamples']>, ParentType, ContextType, Partial<QueryPaginatedPackSamplesArgs>>;
  paginatedPacks?: Resolver<Maybe<ResolversTypes['PaginatedPacks']>, ParentType, ContextType, Partial<QueryPaginatedPacksArgs>>;
  paginatedPacksAndRepacks?: Resolver<Maybe<ResolversTypes['PaginatedPacksOrRepacks']>, ParentType, ContextType, Partial<QueryPaginatedPacksAndRepacksArgs>>;
  paginatedRecommendedSamples?: Resolver<Maybe<ResolversTypes['PaginatedSamples']>, ParentType, ContextType, RequireFields<QueryPaginatedRecommendedSamplesArgs, 'sampleGuid'>>;
  paginatedRepackSamples?: Resolver<Maybe<ResolversTypes['PaginatedSamples']>, ParentType, ContextType, Partial<QueryPaginatedRepackSamplesArgs>>;
  paginatedRepacks?: Resolver<Maybe<ResolversTypes['PaginatedRepacks']>, ParentType, ContextType, Partial<QueryPaginatedRepacksArgs>>;
  paginatedSamples?: Resolver<Maybe<ResolversTypes['PaginatedSamples']>, ParentType, ContextType, Partial<QueryPaginatedSamplesArgs>>;
  paginatedUserCollectionSamples?: Resolver<Maybe<ResolversTypes['PaginatedSamples']>, ParentType, ContextType, Partial<QueryPaginatedUserCollectionSamplesArgs>>;
  paginatedUserCollections?: Resolver<Maybe<ResolversTypes['PaginatedUserCollections']>, ParentType, ContextType, Partial<QueryPaginatedUserCollectionsArgs>>;
  pluginPackages?: Resolver<Maybe<ResolversTypes['PluginPackages']>, ParentType, ContextType>;
  promotionalCardsRepeater?: Resolver<Array<ResolversTypes['PromotionalCard']>, ParentType, ContextType, Partial<QueryPromotionalCardsRepeaterArgs>>;
  repack?: Resolver<Maybe<ResolversTypes['Repack']>, ParentType, ContextType, RequireFields<QueryRepackArgs, 'repackSlugOrGuid'>>;
  repackCostPreview?: Resolver<Maybe<ResolversTypes['CostPreviewResponse']>, ParentType, ContextType, Partial<QueryRepackCostPreviewArgs>>;
  repackPurchase?: Resolver<Maybe<ResolversTypes['PurchaseResponse']>, ParentType, ContextType, Partial<QueryRepackPurchaseArgs>>;
  repackStream?: Resolver<Maybe<ResolversTypes['StreamUrl']>, ParentType, ContextType, RequireFields<QueryRepackStreamArgs, 'repackGuid'>>;
  sample?: Resolver<Maybe<ResolversTypes['Sample']>, ParentType, ContextType, RequireFields<QuerySampleArgs, 'sampleGuid'>>;
  sampleStream?: Resolver<Maybe<ResolversTypes['StreamUrl']>, ParentType, ContextType, RequireFields<QuerySampleStreamArgs, 'sampleGuid'>>;
  sampleWaveform?: Resolver<Maybe<ResolversTypes['Waveform']>, ParentType, ContextType, RequireFields<QuerySampleWaveformArgs, 'sampleGuid' | 'waveformUrl'>>;
  samplesCostPreview?: Resolver<Maybe<ResolversTypes['CostPreviewResponse']>, ParentType, ContextType, Partial<QuerySamplesCostPreviewArgs>>;
  samplesPurchase?: Resolver<Maybe<ResolversTypes['PurchaseResponse']>, ParentType, ContextType, Partial<QuerySamplesPurchaseArgs>>;
  seoByUrl?: Resolver<Maybe<ResolversTypes['Seo']>, ParentType, ContextType, Partial<QuerySeoByUrlArgs>>;
  sfxs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Sfx']>>>, ParentType, ContextType>;
  similarPacks?: Resolver<Maybe<ResolversTypes['PaginatedPacks']>, ParentType, ContextType, RequireFields<QuerySimilarPacksArgs, 'packSlugOrGuid'>>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tag']>>>, ParentType, ContextType>;
  userAgreements?: Resolver<Maybe<ResolversTypes['Agreements']>, ParentType, ContextType>;
  userAllAccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userAllSubscriptions?: Resolver<Maybe<ResolversTypes['AllSubscriptions']>, ParentType, ContextType>;
  userCollection?: Resolver<Maybe<ResolversTypes['UserCollection']>, ParentType, ContextType, Partial<QueryUserCollectionArgs>>;
  userCollections?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserCollection']>>>, ParentType, ContextType, Partial<QueryUserCollectionsArgs>>;
  userCollectionsFeed?: Resolver<Maybe<ResolversTypes['UserCollectionsFeed']>, ParentType, ContextType, Partial<QueryUserCollectionsFeedArgs>>;
  userCredits?: Resolver<Maybe<ResolversTypes['UserCredits']>, ParentType, ContextType>;
  userHasSubscription?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userProfile?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userSamplesSubscription?: Resolver<Maybe<ResolversTypes['CurrentSubscription']>, ParentType, ContextType>;
};

export type RepackResolvers<ContextType = any, ParentType extends ResolversParentTypes['Repack'] = ResolversParentTypes['Repack']> = {
  artist?: Resolver<Maybe<ResolversTypes['Artist']>, ParentType, ContextType>;
  artworkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorSession?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  datePublished?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  foregroundColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genres?: Resolver<Maybe<Array<Maybe<ResolversTypes['Genre']>>>, ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  isDownloaded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isExclusive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFavorited?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFree?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['Label']>, ParentType, ContextType>;
  mainGenre?: Resolver<Maybe<ResolversTypes['Genre']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packState?: Resolver<ResolversTypes['PackState'], ParentType, ContextType>;
  premiumCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['PremiumCodes']>>>, ParentType, ContextType>;
  sampleCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seoMetadata?: Resolver<Maybe<ResolversTypes['SeoMetadata']>, ParentType, ContextType>;
  sfxs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Sfx']>>>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['RepackSubType']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PackType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RepacksChartResolvers<ContextType = any, ParentType extends ResolversParentTypes['RepacksChart'] = ResolversParentTypes['RepacksChart']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['PacksChartItem']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RepacksChartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['RepacksChartItem'] = ResolversParentTypes['RepacksChartItem']> = {
  artistName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  artworkUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currentRank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isNew?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subItemsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sample'] = ResolversParentTypes['Sample']> = {
  bpm?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  descriptors?: Resolver<Maybe<Array<Maybe<ResolversTypes['Descriptor']>>>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  instruments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Instrument']>>>, ParentType, ContextType>;
  isDownloaded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFavorited?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRecommendationFiller?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['SampleKey']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pack?: Resolver<Maybe<ResolversTypes['Pack']>, ParentType, ContextType>;
  sampleState?: Resolver<ResolversTypes['SampleState'], ParentType, ContextType>;
  sampleType?: Resolver<Maybe<ResolversTypes['SampleType']>, ParentType, ContextType>;
  sfxs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Sfx']>>>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tag']>>>, ParentType, ContextType>;
  waveformUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleKeyResolvers<ContextType = any, ParentType extends ResolversParentTypes['SampleKey'] = ResolversParentTypes['SampleKey']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quality?: Resolver<Maybe<ResolversTypes['KeyQuality']>, ParentType, ContextType>;
  root?: Resolver<Maybe<ResolversTypes['KeyRootApi']>, ParentType, ContextType>;
  sanitizedCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeoResolvers<ContextType = any, ParentType extends ResolversParentTypes['Seo'] = ResolversParentTypes['Seo']> = {
  byline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeoItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeoItem'] = ResolversParentTypes['SeoItem']> = {
  seoMetadata?: Resolver<Maybe<ResolversTypes['SeoMetadata']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeoMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeoMetadata'] = ResolversParentTypes['SeoMetadata']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SfxResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sfx'] = ResolversParentTypes['Sfx']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subSfxs?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubItems']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StreamUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['StreamUrl'] = ResolversParentTypes['StreamUrl']> = {
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubItemsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubItems'] = ResolversParentTypes['SubItems']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  onUserCreditsUpdated?: SubscriptionResolver<ResolversTypes['Boolean'], "onUserCreditsUpdated", ParentType, ContextType>;
};

export type SubscriptionPlanProductDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionPlanProductDetails'] = ResolversParentTypes['SubscriptionPlanProductDetails']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currentQuantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isUnlimited?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  maxQuantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfCredits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SubscriptionProductStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagResolvers<ContextType = any, ParentType extends ResolversParentTypes['Tag'] = ResolversParentTypes['Tag']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrackResolvers<ContextType = any, ParentType extends ResolversParentTypes['Track'] = ResolversParentTypes['Track']> = {
  bpm?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bpmMultiplier?: Resolver<Maybe<ResolversTypes['BpmMultiplier']>, ParentType, ContextType>;
  gain?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pitchTranspose?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creationTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  experience?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasSeenArchiveNotification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  homePage?: Resolver<ResolversTypes['HomePageEnum'], ParentType, ContextType>;
  isArchived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  musicGenres?: Resolver<Maybe<Array<Maybe<ResolversTypes['MusicGenre']>>>, ParentType, ContextType>;
  permalink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredCulture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryOccupation?: Resolver<Maybe<ResolversTypes['OccupationEnum']>, ParentType, ContextType>;
  profilePicture72Url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePicture360Url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryOccupations?: Resolver<Maybe<Array<Maybe<ResolversTypes['OccupationEnum']>>>, ParentType, ContextType>;
  signupCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signupCountryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signupState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCollection'] = ResolversParentTypes['UserCollection']> = {
  artworkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateCreated?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  guid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seoMetadata?: Resolver<Maybe<ResolversTypes['SeoMetadata']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCollectionsFeedResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCollectionsFeed'] = ResolversParentTypes['UserCollectionsFeed']> = {
  feed?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserCollection']>>>, ParentType, ContextType, Partial<UserCollectionsFeedFeedArgs>>;
  meta?: Resolver<Maybe<ResolversTypes['MetaPage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCreditsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCredits'] = ResolversParentTypes['UserCredits']> = {
  remaining?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRecentSearchResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRecentSearch'] = ResolversParentTypes['UserRecentSearch']> = {
  filterSlug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  searchFilter?: Resolver<ResolversTypes['UserSearchFilter'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRecentSearchesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRecentSearches'] = ResolversParentTypes['UserRecentSearches']> = {
  recentSearch?: Resolver<Array<ResolversTypes['UserRecentSearch']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaveformResolvers<ContextType = any, ParentType extends ResolversParentTypes['Waveform'] = ResolversParentTypes['Waveform']> = {
  guid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  waveform?: Resolver<Array<Maybe<ResolversTypes['Float']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AbstractCuratedList?: AbstractCuratedListResolvers<ContextType>;
  AbstractCuratedListPage?: AbstractCuratedListPageResolvers<ContextType>;
  AccountBalanceSummary?: AccountBalanceSummaryResolvers<ContextType>;
  Agreement?: AgreementResolvers<ContextType>;
  Agreements?: AgreementsResolvers<ContextType>;
  AllSubscriptions?: AllSubscriptionsResolvers<ContextType>;
  AlternateLanguage?: AlternateLanguageResolvers<ContextType>;
  Artist?: ArtistResolvers<ContextType>;
  Balance?: BalanceResolvers<ContextType>;
  Collection?: CollectionResolvers<ContextType>;
  ContentGroup?: ContentGroupResolvers<ContextType>;
  ContentList?: ContentListResolvers<ContextType>;
  ContentListItem?: ContentListItemResolvers<ContextType>;
  CostPreviewResponse?: CostPreviewResponseResolvers<ContextType>;
  CreatorSession?: CreatorSessionResolvers<ContextType>;
  CreditBalancePayloadType?: CreditBalancePayloadTypeResolvers<ContextType>;
  CuratedList?: CuratedListResolvers<ContextType>;
  CuratedListDataType?: CuratedListDataTypeResolvers<ContextType>;
  CuratedListFeed?: CuratedListFeedResolvers<ContextType>;
  CuratedListGroup?: CuratedListGroupResolvers<ContextType>;
  CuratedListMeta?: CuratedListMetaResolvers<ContextType>;
  CuratedListPage?: CuratedListPageResolvers<ContextType>;
  CurrentSubscription?: CurrentSubscriptionResolvers<ContextType>;
  Date?: GraphQLScalarType;
  Descriptor?: DescriptorResolvers<ContextType>;
  FilterMeta?: FilterMetaResolvers<ContextType>;
  Filters?: FiltersResolvers<ContextType>;
  Genre?: GenreResolvers<ContextType>;
  HeroBanner?: HeroBannerResolvers<ContextType>;
  HeroBannerEntityType?: HeroBannerEntityTypeResolvers<ContextType>;
  Instrument?: InstrumentResolvers<ContextType>;
  Key?: KeyResolvers<ContextType>;
  Label?: LabelResolvers<ContextType>;
  LabelsChart?: LabelsChartResolvers<ContextType>;
  LabelsChartItem?: LabelsChartItemResolvers<ContextType>;
  MerchZone?: MerchZoneResolvers<ContextType>;
  MetaPage?: MetaPageResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NextPage?: NextPageResolvers<ContextType>;
  OverduePayment?: OverduePaymentResolvers<ContextType>;
  Pack?: PackResolvers<ContextType>;
  PackagesMeta?: PackagesMetaResolvers<ContextType>;
  PacksChart?: PacksChartResolvers<ContextType>;
  PacksChartItem?: PacksChartItemResolvers<ContextType>;
  PacksOrRepacks?: PacksOrRepacksResolvers<ContextType>;
  PaginatedArtists?: PaginatedArtistsResolvers<ContextType>;
  PaginatedLabels?: PaginatedLabelsResolvers<ContextType>;
  PaginatedPacks?: PaginatedPacksResolvers<ContextType>;
  PaginatedPacksOrRepacks?: PaginatedPacksOrRepacksResolvers<ContextType>;
  PaginatedRepacks?: PaginatedRepacksResolvers<ContextType>;
  PaginatedSamples?: PaginatedSamplesResolvers<ContextType>;
  PaginatedUserCollections?: PaginatedUserCollectionsResolvers<ContextType>;
  PlanFrequencyIdentifier?: PlanFrequencyIdentifierResolvers<ContextType>;
  PluginPackages?: PluginPackagesResolvers<ContextType>;
  PrismicBackgroundImage?: PrismicBackgroundImageResolvers<ContextType>;
  PrismicBanner?: PrismicBannerResolvers<ContextType>;
  PrismicBannerData?: PrismicBannerDataResolvers<ContextType>;
  PrismicDocument?: PrismicDocumentResolvers<ContextType>;
  PrismicImage?: PrismicImageResolvers<ContextType>;
  PrismicImageDimensions?: PrismicImageDimensionsResolvers<ContextType>;
  PrismicSampleAuthBannerCtaLink?: PrismicSampleAuthBannerCtaLinkResolvers<ContextType>;
  PrismicSampleAuthBannerCtaText?: PrismicSampleAuthBannerCtaTextResolvers<ContextType>;
  PrismicSampleAuthBannerData?: PrismicSampleAuthBannerDataResolvers<ContextType>;
  PrismicSampleAuthBannerDescription?: PrismicSampleAuthBannerDescriptionResolvers<ContextType>;
  PrismicSampleAuthBannerTitle?: PrismicSampleAuthBannerTitleResolvers<ContextType>;
  PrismicSampleBannerData?: PrismicSampleBannerDataResolvers<ContextType>;
  PrismicSampleBannerGroupData?: PrismicSampleBannerGroupDataResolvers<ContextType>;
  PrismicTextField?: PrismicTextFieldResolvers<ContextType>;
  PromotionalCard?: PromotionalCardResolvers<ContextType>;
  PurchaseResponse?: PurchaseResponseResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Repack?: RepackResolvers<ContextType>;
  RepacksChart?: RepacksChartResolvers<ContextType>;
  RepacksChartItem?: RepacksChartItemResolvers<ContextType>;
  Sample?: SampleResolvers<ContextType>;
  SampleKey?: SampleKeyResolvers<ContextType>;
  Seo?: SeoResolvers<ContextType>;
  SeoItem?: SeoItemResolvers<ContextType>;
  SeoMetadata?: SeoMetadataResolvers<ContextType>;
  Sfx?: SfxResolvers<ContextType>;
  StreamUrl?: StreamUrlResolvers<ContextType>;
  SubItems?: SubItemsResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SubscriptionPlanProductDetails?: SubscriptionPlanProductDetailsResolvers<ContextType>;
  Tag?: TagResolvers<ContextType>;
  Track?: TrackResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserCollection?: UserCollectionResolvers<ContextType>;
  UserCollectionsFeed?: UserCollectionsFeedResolvers<ContextType>;
  UserCredits?: UserCreditsResolvers<ContextType>;
  UserRecentSearch?: UserRecentSearchResolvers<ContextType>;
  UserRecentSearches?: UserRecentSearchesResolvers<ContextType>;
  Waveform?: WaveformResolvers<ContextType>;
};

